export default "__VITE_ASSET__774gv7_4__"